module.exports = __webpack_public_path__ + "static/media/home_banner_create_with_ai_pt_br.c0a108f3.png";